import { render } from "./AboutS8.vue?vue&type=template&id=486a91aa&scoped=true"
import script from "./AboutS8.vue?vue&type=script&lang=js"
export * from "./AboutS8.vue?vue&type=script&lang=js"

import "./AboutS8.vue?vue&type=style&index=0&id=486a91aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486a91aa"]])

export default __exports__